import { AutoComplete } from 'antd';
import styled from 'styled-components';
import { MuteText } from '../../elements';
import {
  inventoryPropsalHook,
  useAutocompleteInput,
  useAutocompleteLoading,
  useDebounce,
} from '../../hooks';
import { AutocompleteSearchInput } from '../../components';

const OptionContainer = styled.div`
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

function resultRenderer({ search, location, hasPallet, isEmpty }) {
  const showResult = string => {
    try {
      const highlighted = string.replace(
        new RegExp(search, 'gi'),
        d => `<strong>${d}</strong>`,
      );

      return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
    } catch (error) {
      return string;
    }
  };

  return (
    <OptionContainer key={location?._id}>
      <span>{showResult(location?.code)}</span>
      <div>
        <MuteText>{isEmpty ? '(Empty)' : ''}</MuteText>
        <MuteText className="ml-3">{hasPallet ? 'Pallet' : 'Bin'}</MuteText>
      </div>
    </OptionContainer>
  );
}

export function InventoryProposalSearch({
  onResultClick,
  inputClassName,
  setTableSearch = () => {},
  warehouseId,
  productId,
  currentQuantity,
  newInventory,
}) {
  const { display, query, onSearch, onSelect, clear } =
    useAutocompleteInput(setTableSearch);

  const finalSearch = useDebounce(query, 400);

  const { data, loading } = inventoryPropsalHook(
    warehouseId,
    productId,
    currentQuantity,
    newInventory,
    finalSearch,
  );
  const isSearching = useAutocompleteLoading(query, finalSearch, loading);

  const optionIds = (data ?? []).map(d => d.location?._id).filter(Boolean);

  const options = (data ?? []).map(item => ({
    value: item.location?._id,
    label: resultRenderer({ ...item, search: display }),
  }));

  return (
    <AutoComplete
      style={{ width: '100%' }}
      className={inputClassName}
      value={display}
      options={options}
      filterOption={false}
      placeholder="Search Location"
      classNames={{ popup: { root: 'auto-search-dropdown' } }}
      onSearch={value => onSearch(value, optionIds)}
      onSelect={value => {
        const item = data.find(d => d.location?._id === value);
        if (item) {
          onSelect(item.location?.code || '', () => onResultClick(item));
        }
      }}
    >
      <AutocompleteSearchInput isSearching={isSearching} onClear={clear} />
    </AutoComplete>
  );
}
